// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  getStockPending: false,
  getStockError: null,
  getListStockPending: false,
  getListStockError: null,
  dataList: null, // esta variable se usa para el componente List
  mainCarLotId: null, // esta variable se usa para obtener la concesionaria inicial
  dataGetStock: [],
  reportStockPending: false,
  reportStockError: null,
  stocksProductoPending: false,
  stocksProductoError: null,
  deleteStockPending: false,
  deleteStockError: null,
  getFotoMiniaturaPending: false,
  getFotoMiniaturaError: null,
  loadSchemasFromStockPending: false,
  loadSchemasFromStockError: null,
  basicInfoSchema: {},
  requiredFields: {},
  totalFields: 0,
  advancedInfoSchema: {},
  massiveUploadPending: false,
  massiveUploadError: null,
  carLotConfirmPending: false,
  confirmDownloadPending: false,
  confirmDownloadError: null,
  steps: [
    {
      order: 0,
      label: 'Subir archivo',
      type: '',
      isOptional: false
    },
    {
      order: 1,
      label: 'Validar datos',
      type: '',
      isOptional: false
    },
    {
      order: 2,
      label: 'Confirmar importación',
      type: '',
      isOptional: false
    }
  ],
  currentStep: {
    order: 0,
    label: 'Subir archivo',
    type: '',
    isOptional: false
  },
  massiveUploadFile: null,
  fileName: null,
  downloadStockTemplatePending: false,
  downloadStockTemplateError: null,
  validateInconsistenciesPending: false,
  validateInconsistenciesError: null,
  saveStepPending: false,
  saveStepError: null,
  translator: {},
  massiveUploadDropzoneStatus: 'normal',
  translatorStep: 0,
  lastTranslationStep: 0,
  translatorStepKey: 'carLot',
  saveValidateDataPending: false,
  saveValidateDataError: null,
  messageRouteLeaving: "No terminaste la carga. ¿Querés salir igual?",
  saveValidateDataSuccess: false,
  confirmImportPending: false,
  confirmImportError: null,
  confirmImportSuccess: false,
  confirmImportPartiallySuccess: false,
  completedStepper: false,
  schema: null,
  translatorSteps: null,
  confirmDownloadSuccess: false,
  stocks: null,
  stockToProcess: null,
  editDictionaryTranslationPending: false,
  editDictionaryTranslationError: null,
  editDictionaryTranslationSuccess: false,
  deleteTranslationPending: false,
  deleteTranslationError: null,
  deleteTranslationSuccess: false,
  dictionarySelectedTranslation: null,
  getDictionaryOptionsPending: false,
  dictionaryOptions: null,
  dictionaryOptionsError: null,
  dictionaryAttributes: null,
  getDictionaryAttributesPending: false,
  getDictionaryAttributesError: null,
  getDictionaryCarLotsPending: false,
  dictionaryCarlots: null,
  getDictionaryCarLotsError: null,
  takingCarManagement: {
    currentTakingCar: null,
    companyOptions: [],
    companySelected: null,
    carLotOptions: [],
    carLotDefault: null,
    brandOptions: [],
    brandSelected: null,
    modelOptions: [],
    modelSelected: null,
    reportError: null,
    reportSuccess: false,
    reportPending: false,
    fields: '',
    tab: 0,
    error:null,
    savePending: false,
    saveSuccess: null,
    saveError: null,
    dataStateMachine: null,
    saveStatePending: false,
    saveStateSuccess: false,
    saveStateError: null,
    isFastStockLoading:false,
    mainFilterData: null,
    fastStockLoading: {
      saveData: { files: [] },
      brandOptions: [],
      modelOptions: [],
      yearOptions: [],
      versionOptions: [],
      carLotsOptions: [],
      branchOfficeDefault: null,
      stateOptions: [],
      savedForm: true,
      galeryImagesRowUp: [], 
      galeryImagesRowDown: [],
      pendingFileImage: false,
      errorImagesExpertise: null,
      errorSelectFileImage: null,
      errorDeleteFileImage: null,
      pathToCancel: "",
    },
  },
}

export default initialState
